import { render, staticRenderFns } from "./studentInfoFrom.vue?vue&type=template&id=142f1037&scoped=true"
import script from "./studentInfoFrom.vue?vue&type=script&lang=js"
export * from "./studentInfoFrom.vue?vue&type=script&lang=js"
import style0 from "./studentInfoFrom.vue?vue&type=style&index=0&id=142f1037&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142f1037",
  null
  
)

export default component.exports